import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [55.638397, -5.223121, 35.8],
  [55.638317, -5.223026, 35.8],
  [55.638263, -5.222882, 35.8],
  [55.638226, -5.222715, 35.8],
  [55.63822, -5.222539, 35.8],
];

export default stream;
